// Helper to generate topping display string, using dishMap for missing names
export function getToppingDisplay(
  item: any,
  dishMap?: Record<number | string, any>
): string {
  if (!item.customizes || !Array.isArray(item.customizes)) return ""
  const texts: string[] = []
  // Find the dish in dishMap if available
  const dish = dishMap && item.item_id ? dishMap[item.item_id] : undefined
  const customizeItems = dish?.customize_item || []
  item.customizes.forEach((topping: any) => {
    // Patch topping name if missing
    let toppingName = topping.name
    if ((!toppingName || toppingName === "") && customizeItems.length > 0) {
      const found = customizeItems.find(
        (ci: any) => String(ci.customize_id) === String(topping.id)
      )
      if (found) toppingName = found.customize_item_name
    }
    // Patch option names if missing
    const optionNames = (topping.options || []).map((option: any) => {
      let optionName = option.name
      if ((!optionName || optionName === "") && customizeItems.length > 0) {
        const foundTopping = customizeItems.find(
          (ci: any) => String(ci.customize_id) === String(topping.id)
        )
        const foundOption = foundTopping?.customize_options?.find(
          (opt: any) => String(opt.customize_option_id) === String(option.id)
        )
        if (foundOption) optionName = foundOption.customize_option_name
      }
      return optionName
    })
    if (toppingName && optionNames.length > 0) {
      const display = `${toppingName}: ` + optionNames.join(", ")
      texts.push(display)
    }
  })
  return texts.join("\n")
}
